import { Action } from '@ngrx/store';
import { User, NewUser } from '../../user.interfaces';

export enum UserActionTypes {
	GetMe = '[User] Get Me',
	GetMeSuccess = '[User] Get Me Success',
	GetMeFailure = '[User] Get Me Failure',
	GetAllUsers = '[User] Get All Users',
	GetAllUsersSuccess = '[User] Get All Users Success',
	GetAllUsersFailure = '[User] Get All Users Failure',
	AddUser = '[User] Add User',
	AddUserSuccess = '[User] Add User Success',
	AddUserFailure = '[User] Add User Failure',
	UpdateUser = '[User] Update User',
	UpdateUsers = '[User] Update Users',
	UpdateUserSuccess = '[User] Update User Success',
	UpdateUsersSuccess = '[User] Update Users Success',
	UpdateUserFailure = '[User] Update User Failure',
	DeactivateUser = '[User] Deactivate User',
	DeactivateUserSuccess = '[User] Deactivate User Success',
	DeactivateUserFailure = '[User] Deactivate User Failure',
	SetDefaultSiteForUser = '[User Profile] Set Default Site for User',
	SetDefaultSiteForUserSuccess = '[User Profile] Set Default Site for User Success',
	SetDefaultSiteForUserFailure = '[User Profile] Set Default Site for User Failure',
	AcceptEula = '[User Profile] Accept Eula',
	AcceptEulaSuccess = '[User Profile] Accept Eula Success',
	AcceptEulaFailure = '[User Profile] Accept Eula Failure',
}

export class GetMeSuccess implements Action {
	readonly type = UserActionTypes.GetMeSuccess;

	constructor(public user: User) {}
}

export class GetMeFailure implements Action {
	readonly type = UserActionTypes.GetMeFailure;

	constructor(public error: string) {}
}

export class GetMe implements Action {
	readonly type = UserActionTypes.GetMe;
}

export class GetAllUsers implements Action {
	readonly type = UserActionTypes.GetAllUsers;

	constructor(public siteId: string) {}
}

export class GetAllUsersSuccess implements Action {
	readonly type = UserActionTypes.GetAllUsersSuccess;

	constructor(public users: User[]) {}
}

export class GetAllUsersFailure implements Action {
	readonly type = UserActionTypes.GetAllUsersFailure;

	constructor(public error: any) {}
}

export class AddUser implements Action {
	readonly type = UserActionTypes.AddUser;

	constructor(public user: NewUser) {}
}

export class AddUserSuccess implements Action {
	readonly type = UserActionTypes.AddUserSuccess;

	constructor(public user: User) {}
}

export class AddUserFailure implements Action {
	readonly type = UserActionTypes.AddUserFailure;

	constructor(public error: string) {}
}

export class UpdateUser implements Action {
	readonly type = UserActionTypes.UpdateUser;

	constructor(public userId: string, public user: NewUser) {}
}

export class UpdateUsers implements Action {
	readonly type = UserActionTypes.UpdateUsers;

	constructor(public users: NewUser[], public unmodifiedUsers: {}, public roleName: string) {}
}

export class UpdateUserSuccess implements Action {
	readonly type = UserActionTypes.UpdateUserSuccess;

	constructor(public user: User) {}
}

export class UpdateUsersSuccess implements Action {
	readonly type = UserActionTypes.UpdateUsersSuccess;

	constructor(public users: NewUser[]) {}
}

export class UpdateUserFailure implements Action {
	readonly type = UserActionTypes.UpdateUserFailure;

	constructor(public error: string) {}
}

export class DeactivateUser implements Action {
	readonly type = UserActionTypes.DeactivateUser;

	constructor(public userId: string, public siteId: string) {}
}

export class DeactivateUserSuccess implements Action {
	readonly type = UserActionTypes.DeactivateUserSuccess;

	constructor(public userId: string) {}
}

export class DeactivateUserFailure implements Action {
	readonly type = UserActionTypes.DeactivateUserFailure;

	constructor(public error: string) {}
}

export class SetDefaultSiteForUser implements Action {
	readonly type = UserActionTypes.SetDefaultSiteForUser;

	constructor(public siteId: string) {}
}

export class SetDefaultSiteForUserSuccess implements Action {
	readonly type = UserActionTypes.SetDefaultSiteForUserSuccess;

	constructor(public user: User) {}
}

export class SetDefaultSiteForUserFailure implements Action {
	readonly type = UserActionTypes.SetDefaultSiteForUserFailure;

	constructor(public error: string) {}
}

export class AcceptEula implements Action {
	readonly type = UserActionTypes.AcceptEula;

	constructor() {}
}

export class AcceptEulaSuccess implements Action {
	readonly type = UserActionTypes.AcceptEulaSuccess;

	constructor() {}
}

export class AcceptEulaFailure implements Action {
	readonly type = UserActionTypes.AcceptEulaFailure;

	constructor(public error: string) {}
}

export type UserActionsUnion =
	| GetMe
	| GetMeSuccess
	| GetMeFailure
	| GetAllUsers
	| GetAllUsersSuccess
	| GetAllUsersFailure
	| AddUser
	| AddUserSuccess
	| AddUserFailure
	| UpdateUser
	| UpdateUsers
	| UpdateUsersSuccess
	| UpdateUserSuccess
	| UpdateUserFailure
	| DeactivateUser
	| DeactivateUserSuccess
	| DeactivateUserFailure
	| SetDefaultSiteForUser
	| SetDefaultSiteForUserSuccess
	| SetDefaultSiteForUserFailure
	| AcceptEula
	| AcceptEulaSuccess
	| AcceptEulaFailure;
